export default __webpack_public_path__ + "static/media/table.ac05eecd.svg";